import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ImageData, ImagesService, Resolution } from '@libraries/assets';
import { ButtonConfig } from '@libraries/design-system';
import { animationFrameScheduler, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'mobile-title-image',
  templateUrl: './mobile-title-image.component.html',
  styleUrls: ['./mobile-title-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MobileTitleImageComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() subtitle: string;

  _imageName: string;
  @Input()
  set imageName(name: string) {
    this._imageName = `${name}Mobile`;
    this.image$ = this.images.get$(this.imageName);
  }
  get imageName() {
    return this._imageName;
  }

  @Input() button: ButtonConfig;
  @Output() buttonAction = new EventEmitter();

  private alive = true;
  @HostBinding('style.margin-bottom') marginBottom = '1rem';
  offsetHeight: number;
  overlayLifted = false;
  mobile = Resolution.mobile;
  image$: Observable<ImageData>;

  scrollX: number;
  scrollY: number;
  scrollableImage: HTMLDivElement;
  animationRef: Subscription;

  constructor(private el: ElementRef, private zone: NgZone, private images: ImagesService) {}

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      this.scrollableImage = document.querySelector(`#scrollableImage`);
      this.animationRef = animationFrameScheduler.schedule(this.scrollLoop);
    });

    if (this.button) {
      this.marginBottom = '-0.5rem';
      this.overlayLifted = true;
    }
  }

  ngOnDestroy = () => this.animationRef.unsubscribe();

  setHeight = () => (this.offsetHeight = this.el.nativeElement.offsetHeight + 80);

  scrollLoop = () => {
    this.scrollY = document.scrollingElement.scrollTop || document.documentElement.scrollTop;
    this.scrollableImage.style.transform = `translate3d(0, ${this.scrollY * 0.32}px, 0)`;
    animationFrameScheduler.schedule(this.scrollLoop);
  };
}
